import { render, staticRenderFns } from "./CajaSeguridad.vue?vue&type=template&id=0c81224a&scoped=true"
import script from "./CajaSeguridad.vue?vue&type=script&lang=js"
export * from "./CajaSeguridad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c81224a",
  null
  
)

export default component.exports